<template>
  <div
    class="md-layout-item md-size-33 md-large-size-33 md-medium-size-50 md-xsmall-size-100"
  >
    <md-card style="min-height: 300px">
      <md-card-header class="md-card-header-text md-card-header-primary handle">
        <div class="card-text card-text--dashboard">
          <h4 class="title">
            <template v-if="value.title">{{ value.title }}</template>
            <template v-else>{{ $t(`widget.${value.name}.name`) }}</template>
          </h4>
        </div>
      </md-card-header>
      <md-card-content style="height: 215px">
        <component
          v-bind:is="value.name"
          v-model="value"
          :key="key"
          :ref="'component' + key"
        ></component>
      </md-card-content>
      <md-card-actions style="justify-content: space-between">
        <template v-if="!value.ShowOptions">
          <md-button
            class="md-button md-simple md-just-icon"
            @click="toggleShowOptions()"
          >
            <md-icon>settings</md-icon>
          </md-button>
          <template v-if="value.fullSize !== undefined">
            <md-button
              class="md-button md-simple md-just-icon"
              @click="openFullSizeView"
            >
              <md-icon>aspect_ratio</md-icon>
            </md-button>
          </template>
          <template v-else>
            <div></div>
          </template>
          <md-button
            class="md-button md-simple md-just-icon"
            @click="removeWidget"
          >
            <md-icon>delete</md-icon>
          </md-button>
        </template>
        <template v-else>
          <md-button
            class="md-button md-simple md-just-icon md-danger"
            @click="value.ShowOptions = false"
          >
            <md-icon>close</md-icon>
          </md-button>
          <md-button
            class="md-button md-simple md-just-icon md-success"
            @click="$refs['component' + key].saveOptions()"
          >
            <md-icon>done</md-icon>
          </md-button>
        </template>
      </md-card-actions>
    </md-card>
    <modal v-if="classicModal" @close="classicModal = false">
      <template slot="header">
        <h4 class="modal-title">
          <template v-if="value.title">{{ value.title }}</template>
          <template v-else>{{ $t(`widget.${value.name}.name`) }}</template>
        </h4>
        <md-button
          class="md-danger md-simple md-just-icon md-round modal-default-button"
          @click="classicModal = false"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <component
          v-bind:is="value.name"
          v-model="value"
          :key="key"
          :ref="'component' + key"
          :full-size="true"
        ></component>
      </template>

      <template slot="footer">
        <!--                <md-button class="md-danger md-simple" @click="classicModal = false">Close</md-button>-->
      </template>
    </modal>
  </div>
</template>

<script>
import * as Widgets from "@/components/Dashboard/Widgets/";
import { Modal } from "wings-ui-components";

export default {
  components: { ...Widgets, Modal },
  name: "DashboardWidgetCardWings",
  props: {
    value: {},
  },
  data() {
    return {
      key: 0,
      classicModal: false,
    };
  },
  mounted() {
    if (this.value.ShowOptions) {
      this.getTransports();
    }
  },
  methods: {
    toggleShowOptions() {
      this.value.ShowOptions = !this.value.ShowOptions;
      if (this.value.ShowOptions) {
        this.getTransports();
      }
    },
    async getTransports() {
      if (this.$store.getters.transports.length === 0) {
        await this.$store.dispatch("getTransports");
      }
    },
    openFullSizeView(){
      this.classicModal = true;
      this.$refs['component' + this.key].openFullSizeView();
    },
    removeWidget(){
      this.$emit('remove');
      this.$refs['component' + this.key].removeWidget()
    }
  },
};
</script>

<style>
.handle {
  cursor: move;
}

.md-button.md-just-icon {
  width: 24px;
  height: 25px;
  line-height: 24px;
}

.md-card .md-card-actions {
  padding-top: 0;
}
</style>
